import { render, staticRenderFns } from "./AffiliateDetailsModal.vue?vue&type=template&id=33c4d7bc"
import script from "./AffiliateDetailsModal.vue?vue&type=script&lang=js"
export * from "./AffiliateDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports